module.exports = __webpack_public_path__ + "img/拉手锁 (3).07c197b1.png";